
export const convertHexToRGBA = (hexCode, opacity = 1) => {
  let hex = hexCode.replace("#", "");

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  /* Backward compatibility for whole number based opacity values. */
  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return `rgba(${r},${g},${b},${opacity})`;
};

export const getQueryParams = (paramKey) => {
  const queryParams = window.location.search.substring(1)
  const params = queryParams.split('&')
  for (let i = 0; i < params.length; i++) {
    const paramKeyAndValue = params[i].split('=')
    if (paramKeyAndValue[0] === paramKey) {
      return paramKeyAndValue[1]
    }
  }
  return ''
}

export const getQueryParamsBySearch = (search,paramKey) => {
  const queryParams = search.substring(1)
  const params = queryParams.split('&')
  for (let i = 0; i < params.length; i++) {
    const paramKeyAndValue = params[i].split('=')
    if (paramKeyAndValue[0] === paramKey) {
      return paramKeyAndValue[1]
    }
  }
  return ''
}

export const getDeviceBattery = (batteryHex) => {
  const currentVoltage = handleHexStringToUInt16(batteryHex)
  if (currentVoltage <= 100) {
    return currentVoltage;
  }

  const currentVoltagesMax = 4000
  const currentVoltagesMin = 3300
  if (currentVoltage >= 4000) {
    return 100;
  } else if (currentVoltage <= currentVoltagesMin) {
    return 0;
  }
  return parseInt((((currentVoltage - currentVoltagesMin) / (currentVoltagesMax - currentVoltagesMin)) * 100).toFixed(1))
}

export const getDeviceLiquid = (currentSecondHex, maxSecondHex) => {
  const currentSecond = handleHexStringToUInt16(currentSecondHex)
  const maxSecond = handleHexStringToUInt16(maxSecondHex)
  const idleSecond = maxSecond - currentSecond
  if (idleSecond <= 0) {
    return 0
  }
  return Math.round((idleSecond / maxSecond) * 100)
}

export const handleHexStringToUInt16 = (hex) => {
  let hexStr = hex;
  if (hexStr.length % 2 !== 0) {
    hexStr = `0${hexStr}`
  }

  let buffer = Buffer.alloc(2);
  buffer[0] = parseInt(hexStr.slice(0, 2), 16);
  buffer[1] = parseInt(hexStr.slice(2, 4), 16);
  const dataView = new DataView(buffer.buffer);
  return dataView.getUint16(0, true)
}

export const NO_CARTRIDGE = -1
export const ERROR_CARTRIDGE = -2
export const CORRECT_CARTRIDGE = 1
export const PATTERN = {
  EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/,
};


export function isAndroid() {
  return (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1);
}
export function androidWriteFail(isRead) {
  return {
    title: "",
    message: `${(isRead? 'Read':'Write')} fail!`,
    icon: require('@/assets/android_nfc_fail.svg'),
    status: ANDROID_NFC_FAIL
  }
}

export function androidWriteSuccess(isRead) {
  return {
    title: "",
    message: `${(isRead? 'Read':'Write')} Success!`,
    icon: require('@/assets/android_nfc_success.svg'),
    status: ANDROID_NFC_SUCCESS
  }
}
export const ANDROID_NFC_START = 0;
export const ANDROID_NFC_SUCCESS = 1;
export const ANDROID_NFC_FAIL = -1;